import React from 'react';
import styled from 'styled-components';
import { useState, useEffect, useRef } from 'react';
import moment from "moment";
import $ from 'jquery';
import { findDOMNode } from 'react-dom';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const FaqAccoLiBlock = styled.li`

`;

const FaqAccoTitleboxBlock = styled.div`

`;

const FaqAccoQnaSpanBlock = styled.span`

`;
const FaqAccoQnaIconSpanBlock = styled.span`

`;
const FaqAccoCateSpanBlock = styled.span`

`;

const FaqAccoTitleH4Block = styled.h4`
    ${isMobileOnly&&`
        width : 60vw; /* 구식 브라우저를 위한 대비책(fallback) */
        width : -webkit-calc(100% - 120px); /* for Chrome, Safari */
        width : -moz-calc(100% - 120px); /* for Firefox */
        width : calc(100% - 120px); 
        display: block;
        float: left;
        padding: 28px 0;
    `};
`;

const FaqAccoDateSpanBlock = styled.span`

`;

const FaqAccoArrowSpanBlock = styled.span`

`;


const FaqAccoConBoxBlock = styled.div`

${isMobileOnly?`
    ::after {
        content: '';
        position: absolute;
        top: 30px;
        left: 5px;
        //right: 34px
        //bottom : 30px;
        display: block;
        width: 30px;
        height: 30px;
        background: url(/assets/images/icon/qna_a-icon.png) center center/auto no-repeat;
    }  
    `:`
    ::after {
        content: '';
        position: absolute;
        top: 30px;
        left: 34px;
        //right: 34px
        //bottom : 30px;
        display: block;
        width: 30px;
        height: 30px;
        background: url(/assets/images/icon/qna_a-icon.png) center center/auto no-repeat;
    }
    `};

`;

const FaqAccoConBlock = styled.div`

`;

const CateOption = [
    { value: "all", label: "전체" },
    { value: "125101", label: "견적" },
    { value: "125102", label: "주문/결제" },
    { value: "125103", label: "배송" },
    { value: "125104", label: "취소/환불" },
    { value: "125105", label: "교환/반품" },
    { value: "125106", label: "기타" },
];

//const $ = window.$

const FaqAccoItem = ({ dataInfo, active, clickHandler}) => {
    const answerRef = useRef(null);

    const handleActiveClass = () => {
        if(answerRef.current){
            const el = answerRef.current;//findDOMNode(answerRef.current);
            if(active){
                $(el).slideDown();
                $(el).parents('li').addClass('active');
            }
            else {
                $(el).slideUp();
                $(el).parents('li').removeClass('active');
            }
        }

    }

    //처음 진입시에 answerRef 생성 되지 않은 경우, 생성 후, 화면 열도록 함.
    useEffect(() => {
        if(answerRef.current){
            const el = answerRef.current;//findDOMNode(answerRef.current);
            if(active){
                $(el).slideDown();
                $(el).parents('li').addClass('active');
            }
            else {
                $(el).slideUp();
                $(el).parents('li').removeClass('active');
            }
        }
    }, [answerRef])

    const getTitleCate = () => {
        for(var i =0 ; i < CateOption.length ; i++){
            if(dataInfo.faq_type === CateOption[i].value){
                return CateOption[i].label;
            }
        }
    }
    if(dataInfo === null || dataInfo.answer === null || dataInfo.answer === undefined) {
        return <div></div>
    }

    return (isMobileOnly ?
        <FaqAccoLiBlock className={handleActiveClass()}>
            <FaqAccoTitleboxBlock className="da-title-box clearfix" onClick = {() => clickHandler(dataInfo.id)}>
                <FaqAccoQnaSpanBlock className="da-qna" style={{ paddingTop: '20px', paddingBottom: '20px', width: '40px' }}>
                    <FaqAccoQnaIconSpanBlock className="qna-icon" style={{ width: '100%' }}/>
                </FaqAccoQnaSpanBlock>
                <FaqAccoCateSpanBlock className="da-cate" style={{ width: 'fit-content', minWidth: '70px' }}>
                    [{getTitleCate()}]
                </FaqAccoCateSpanBlock>
                <FaqAccoTitleH4Block className="da-title2 long" style={{ paddingLeft: '2vw', paddingRight: '1vw' }}>
                    {dataInfo.question}
                </FaqAccoTitleH4Block>
                {/* <FaqAccoArrowSpanBlock className="da-arrow"></FaqAccoArrowSpanBlock> */}
            </FaqAccoTitleboxBlock>
            <FaqAccoConBoxBlock ref={answerRef} className="da-con-box answer2"
            style={{borderTop: '1px solid #eee', minHeight: '0px', backgroundColor: '#f4f4f4', color: '#666', padding: '30px 3vw 30px 15vw'}}>
                <FaqAccoConBlock className="da-con" style={{ paddingLeft: '1vw', paddingRight: '1vw' }}>
                    {/* <div dangerouslySetInnerHTML={{ __html: dataInfo.answer }} ></div> */}
                    {
                        //console.log("dataInfo.answer" + dataInfo.answer)
                        (dataInfo.answer !== null && typeof(dataInfo.answer) === "string" && dataInfo.answer.length > 0 && dataInfo.answer.indexOf("\n") > -1 ? dataInfo.answer.split("\n").map(function(item, idx) {
                            return (
                                <span key={idx}>
                                    {item}
                                    <br/>
                                </span>
                            )
                        }) : dataInfo.answer)

                    }
                </FaqAccoConBlock>
            </FaqAccoConBoxBlock>
        </FaqAccoLiBlock>
        :
        <FaqAccoLiBlock className={handleActiveClass()}>
            <FaqAccoTitleboxBlock className="da-title-box clearfix" onClick = {() => clickHandler(dataInfo.id)}>
                <FaqAccoQnaSpanBlock className="da-qna" style={{ paddingTop: '20px', paddingBottom: '20px', width: '98px' }}>
                    <FaqAccoQnaIconSpanBlock className="qna-icon" style={{ width: '68px' }}/>
                </FaqAccoQnaSpanBlock>
                <FaqAccoCateSpanBlock className="da-cate" style={{ width: '90px' }}>
                    [{getTitleCate()}]
                </FaqAccoCateSpanBlock>
                <FaqAccoTitleH4Block className="da-title long" style={{ paddingLeft: '20px', paddingRight: '20px', width: '920px' }}>
                    {dataInfo.question}
                </FaqAccoTitleH4Block>
                <FaqAccoArrowSpanBlock className="da-arrow"></FaqAccoArrowSpanBlock>
            </FaqAccoTitleboxBlock>
            <FaqAccoConBoxBlock ref={answerRef} className="da-con-box answer2"
            style={{borderTop: '1px solid #eee', minHeight: '0px', backgroundColor: '#f4f4f4', color: '#666'}}>
                <FaqAccoConBlock className="da-con" style={{ paddingLeft: '97px', paddingRight: '58px' }}>
                    {/* <div dangerouslySetInnerHTML={{ __html: dataInfo.answer }} ></div> */}
                    {
                        //console.log("dataInfo.answer" + dataInfo.answer)
                        (dataInfo.answer !== null && typeof(dataInfo.answer) === "string" && dataInfo.answer.length > 0 && dataInfo.answer.indexOf("\n") > -1 ? dataInfo.answer.split("\n").map(function(item, idx) {
                            return (
                                <span key={idx}>
                                    {item}
                                    <br/>
                                </span>
                             )
                        }) : dataInfo.answer)

                    }
                </FaqAccoConBlock>
            </FaqAccoConBoxBlock>
        </FaqAccoLiBlock>);
};

export default FaqAccoItem;
